import { SortWrapper } from 'components/EntityBrowser/atoms';
import styled, { css } from 'styled-components';
import { BasicTable } from '@ardoq/table-legacy';
import { SortOrder } from '@ardoq/api-types';
import { Icon, IconProps } from '@ardoq/icons';
import { colors } from '@ardoq/design-tokens';
import { FlexBox } from '@ardoq/layout';

type SortHeaderProps = {
  className?: string;
  onSortChanged: (sortByField: string) => void;
  sortOrder: SortOrder;
  dataClickId: string;
  title: string;
  sortByField: string | null;
  dataIndex: string;
  iconProps?: IconProps;
  tooltipText?: string;
};

const SortHeader = ({
  dataIndex,
  className,
  onSortChanged,
  sortOrder,
  dataClickId,
  title,
  sortByField,
  iconProps,
  tooltipText,
}: SortHeaderProps) => (
  <SortWrapper
    className={className}
    onClick={() => onSortChanged(dataIndex)}
    data-click-id={dataClickId}
  >
    <FlexBox align="center">
      {iconProps && (
        <Icon
          {...iconProps}
          color={iconProps.color ?? colors.grey500}
          data-tooltip-text={tooltipText}
        />
      )}
      {title}
      {sortByField === dataIndex && <BasicTable.SortIcon order={sortOrder} />}
    </FlexBox>
  </SortWrapper>
);

export { SortHeader };

export const SortHeaderWithOffset = styled(SortHeader)<{
  $offsetMargin: number;
}>`
  ${({ $offsetMargin }) =>
    $offsetMargin &&
    css`
      margin-left: ${$offsetMargin}px;
      flex: 1;
    `}
`;
